// OFinancial Markets brand logo · single-asset, theme-aware.
// The shipped SVG (/brand/svg/OFin_logo_H.svg) carries a hardcoded
// cyan fill (#aadeeb) which reads fine on dark surfaces but turns
// near-white on light backgrounds. We use a CSS `filter` chain to
// repaint the entire glyph in light-mode so the wordmark stays
// legible without shipping a second asset.
import { useTheme } from "@/contexts/ThemeContext";

/* `forceTheme` overrides the global ThemeContext for surfaces that
   are pinned to a fixed colour scheme regardless of the visitor's
   preference (e.g. the admin console which forces `html.dark`).
   Without this, a light-mode visitor opening /admin/dashboard sees
   the black-filtered glyph painted on the admin's hard-coded dark
   background · invisible. Pass `forceTheme="dark"` there. */
export function OFundedLogo({ className = "h-8 w-auto", forceTheme }) {
  const { theme } = useTheme();
  const effective = forceTheme || theme;
  const isLight = effective === "light";
  return (
    <img
      src="/brand/svg/OFin_logo_H.svg"
      alt="OFinancial.markets"
      className={className}
      draggable={false}
      // brightness(0) → pure black silhouette · then invert+saturate to
      // remap to OFinancial's near-black brand text colour, so the
      // wordmark reads as dark-ink on the light surface.
      style={isLight ? { filter: "brightness(0) saturate(100%)" } : undefined}
    />
  );
}

export function OFundedIcon({ className = "h-9 w-9", forceTheme }) {
  const { theme } = useTheme();
  const effective = forceTheme || theme;
  const isLight = effective === "light";
  return (
    <img
      src="/brand/svg/logo.svg"
      alt=""
      aria-hidden
      className={className}
      draggable={false}
      style={isLight ? { filter: "brightness(0) saturate(100%)" } : undefined}
    />
  );
}
